import axios from 'axios';
import { put, takeLatest, takeEvery } from 'redux-saga/effects';

function* fetchNameRequests(action) {
    try {
        const response = yield axios.get('/api/requests/name');
       
        yield put({ type: 'SET_NAME_REQUESTS', payload: response.data });
    } catch (error) {
        console.log('Error fetching requests', error);
    }
}
function* requestNameSaga(){
    yield takeEvery('FETCH_NAME_REQUESTS', fetchNameRequests);
}
export default requestNameSaga;